import React, { useState } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

const DrawerCard = ({ top, bottom, isOpen, onClick, cardIndex }) => {
  const [localOpen, setLocalOpen] = useState(false);
  const openState = isOpen !== undefined ? isOpen : localOpen;

  const handleClick = () => {
    setLocalOpen(!localOpen);
    if (onClick) onClick(!localOpen, cardIndex);
  };

  return (
    <article
      id={cardIndex ? `DrawerCard-${cardIndex}` : undefined}
      className="rounded-2xl p-6 w-full transition-all hover:bg-gray-200 shadow-lg hover:shadow-xl bg-white cursor-pointer"
      onClick={handleClick}
    >
      <div
        className={`w-full text-left ${openState ? "font-bold" : "font-normal"}`}
      >
        {top}
      </div>
      <div
        className={`text-gray-800 transition-all ease-out ${openState ? "mt-2 py-3" : ""}`}
      >
        {openState ? bottom : <></>}
      </div>
    </article>
  );
};

export const drawerCardControls = {
  top: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Card content",
    disable: true,
  },
  bottom: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Card content",
    disable: true,
  },
  onClick: {
    propType: PropTypes.func,
    description: "Card clicking action",
    controlType: "function",
    defaultValue: () => alert("clicking card"),
  },
  shadow: {
    propType: PropTypes.bool,
    description: "Enable card shadow",
    controlType: "boolean",
    defaultValue: false,
  },
  cardIndex: {
    propType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    description:
      "Card index to use when parent is monitoring several drawer cards",
    controlType: "text",
  },
};

DrawerCard.propTypes = AppUtils.getPropTypeFromControls(drawerCardControls);

export default DrawerCard;
